import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import {
  getTradeResponse,
  saveTradeResponse,
} from '../services/tradeResponseService';

class TradeResponseForm extends Form {
  state = {
    data: {
      name: '',
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    name: Joi.string().required().label('Trade Response'),
  };

  async populateTradeResponse() {
    try {
      const tradeResponseId = this.props.match.params.id;
      if (tradeResponseId === 'new') return;

      const { data: tresponse } = await getTradeResponse(tradeResponseId);
      this.setState({ data: this.mapToViewModel(tresponse) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    await this.populateTradeResponse();
  }

  mapToViewModel(tresponse) {
    return {
      _id: tresponse._id,
      name: tresponse.name,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    await saveTradeResponse(data);

    this.props.history.push('/trade-responses');
  };

  render() {
    const tradeResponseId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + 'px' }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
            >
              Create a Trade Response
            </h4>
            <p style={{ color: '#000524' }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 2 + '%',
                fontWeight: 'bold',
              }}
            >
              Trade Response
            </div>
            <hr
              style={{
                marginRight: 20 + 'px',
                marginLeft: 20 + 'px',
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-12">
                    {this.renderInput(
                      'name',
                      'Trade Response',
                      '',
                      'autofocus',
                      'text'
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {tradeResponseId === 'new'
                    ? this.renderButton('Save')
                    : this.renderButton('Update')}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TradeResponseForm;
